import ViewportType from './ViewportType';
const builtInViewportTypes = {
    STACK: ViewportType.STACK,
    ORTHOGRAPHIC: ViewportType.ORTHOGRAPHIC,
    PERSPECTIVE: ViewportType.PERSPECTIVE,
    VOLUME_3D: ViewportType.VOLUME_3D,
    VOLUME_3D_NEXT: ViewportType.VOLUME_3D_NEXT,
    PLANAR_NEXT: ViewportType.PLANAR_NEXT,
    VIDEO: ViewportType.VIDEO,
    VIDEO_NEXT: ViewportType.VIDEO_NEXT,
    WHOLE_SLIDE: ViewportType.WHOLE_SLIDE,
    WHOLE_SLIDE_NEXT: ViewportType.WHOLE_SLIDE_NEXT,
    ECG: ViewportType.ECG,
    ECG_NEXT: ViewportType.ECG_NEXT,
};
const ViewportTypes = builtInViewportTypes;
export function registerViewportTypesConstant(name, type) {
    if (Object.prototype.hasOwnProperty.call(ViewportTypes, name)) {
        throw new Error(`Viewport type constant "${String(name)}" already exists`);
    }
    ViewportTypes[name] = type;
}
export default ViewportTypes;
